import ConfigurablePadding from './_configurable-padding.js'
import ConfigurableBorder from './_configurable-border.js'
import ConfigurableBackground from './_configurable-background.js'
import ConfigurableText from './_configurable-text.js'

export default {
  name: 'ConfigurablePane',
  values: {
    boxSizing: undefined,
    boxShadow: undefined,
    opacity: undefined,
    aspectRatio: undefined,
    gap: undefined,
    scrollSnapType: undefined,
    scrollSnapStop: undefined,
    scrollSnapAlign: undefined,
    $mixin: [
      {
        configSet: ConfigurablePadding,
      },
      {
        configSet: ConfigurableBorder,
      },
      {
        configSet: ConfigurableBackground,
      },
      {
        configSet: ConfigurableText,
      },
    ],
  },
  meta: {
    extendable: false,
  },
}
